if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.initCustomNavigation();
      }

      initCustomNavigation() {
        const navigation = this.querySelector('.product-media-modal__navigation');
        const content = this.querySelector('.product-media-modal__content');
        
        // Prevent background click from being blocked if it's actually the background
        this.addEventListener('pointerup', (e) => {
          // If we click navigation or image, stop propagation so ModalDialog doesn't hide
          if (e.target.closest('.product-media-modal__navigation') || e.target.tagName === 'IMG') {
            e.stopImmediatePropagation();
          }
          // Otherwise, let it bubble so ModalDialog.hide() is called (closing on background)
        }, true);

        this.querySelector('.product-media-modal__nav-button--prev')?.addEventListener('click', (e) => {
          e.stopPropagation();
          this.navigate(-1);
        });
        this.querySelector('.product-media-modal__nav-button--next')?.addEventListener('click', (e) => {
          e.stopPropagation();
          this.navigate(1);
        });
        this.querySelector('.product-media-modal__nav-button--close')?.addEventListener('click', (e) => {
          e.stopPropagation();
          this.hide();
        });
        
        // Real Zoom Logic
        content?.addEventListener('click', (event) => {
          const item = event.target.closest('.product-media-modal__item.active');
          if (!item) return;

          const img = event.target.closest('img');
          // If we didn't click an image but clicked the background area, close the modal
          if (!img) {
            this.hide();
            return;
          }

          event.stopPropagation();
          
          if (!item.classList.contains('is-zoomed')) {
            // Zoom In
            item.classList.add('is-zoomed');
            const rect = img.getBoundingClientRect();
            const x = ((event.clientX - rect.left) / rect.width) * 100;
            const y = ((event.clientY - rect.top) / rect.height) * 100;
            img.style.transformOrigin = `${x}% ${y}%`;
          } else {
            // Zoom Out
            item.classList.remove('is-zoomed');
            setTimeout(() => {
              img.style.transformOrigin = 'center center';
            }, 300);
          }
        });
      }

      navigate(direction) {
        const active = this.querySelector('.product-media-modal__content > .active');
        const items = Array.from(this.querySelectorAll('.product-media-modal__content > .product-media-modal__item'));
        let index = items.indexOf(active);
        
        index += direction;
        if (index < 0) index = items.length - 1;
        if (index >= items.length) index = 0;
        
        const newActive = items[index];
        const content = this.querySelector('.product-media-modal__content');
        
        // Reset zoom on navigation instantly
        active.classList.remove('is-zoomed');
        content.style.scrollBehavior = 'auto';
        content.scrollTo({ left: 0, top: 0 });
        
        active.classList.remove('active');
        newActive.classList.add('active');
        
        // Restore scroll behavior
        setTimeout(() => {
          content.style.scrollBehavior = '';
        }, 10);
      }

      hide() {
        // Reset all zoom states on close
        this.querySelectorAll('.product-media-modal__item').forEach(item => {
          item.classList.remove('is-zoomed');
        });
        const content = this.querySelector('.product-media-modal__content');
        if (content) content.scrollTo({ left: 0, top: 0 });
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll('.product-media-modal__content > .product-media-modal__item').forEach((element) => {
          element.classList.remove('active');
          element.classList.remove('is-zoomed');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        if (activeMedia) activeMedia.classList.add('active');
      }
    }
  );
}
